import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";

export const deletePledge = ({ churchId, campaignId, pledgeId }) => {
  return axios.delete(
    `/churches/${churchId}/campaigns/${campaignId}/pledges/${pledgeId}`
  );
};

export const useDeletePledge = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const closeDeleteModal = useCentralStore.getState().closeDeleteModal;

  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries("pledges-paginated");

      setNotification({
        type: "success",
        message: "Pledge deleted successfully!"
      });
      closeDeleteModal();
    },
    ...config,
    mutationFn: deletePledge
  });
};
